const rootCreditos = process.env.REACT_APP_SERVICE_CALC_CRED_BASE;
const rootApiCMS = process.env.REACT_APP_API_GRAPHQL;

const perfilCorporativoRoute =
  rootApiCMS +
  "?query={serviahorro(status:PUBLISHED){titulo descripcion{html} botonEnlaceImagen(status:PUBLISHED){urls} botonEnlaceUrl(status:PUBLISHED){url}}}";
const sucursalesRoute =
  rootApiCMS +
  "?query={aCBotonComoLlegar(status:PUBLISHED){imagen{urls} imagenMovil{urls}} aCSucursalBannerBackground(status:PUBLISHED){imagendeFondo{urls} imagendeFondoIpadPortrait{urls} imagendefondoMovil{urls} heroImage{urls} copyText}}";
const conveniosRoute =
  rootApiCMS +
  "?query={aCBannerConvenios(status: PUBLISHED){imagendefondo{urls} imagendeFondoIpad{urls} imagendefondoMovil{urls} heroImage{urls} copyText{html} descripcion{html}}}";
const creditosPersonalesRoute =
  rootApiCMS +
  "?query={aCCreditosPersonales(status:PUBLISHED){idCredito titulo resumen{html} descripcion{html} imagen{urls} bag{contentItems{... on TituloDescripcion{title description{html}}}} urlFormularioSoliciteCredito{url text}} aCBotonSoliciteSuCredito{ imagen{urls} imagen2x{urls} imagen3x{urls}} aCBotonCalculesuCredito{ imagen{urls} imagen2x{urls} imagen3x{urls}}}";
const creditosHipotecariosRoute =
  rootApiCMS +
  "?query={aCCreditosHipotecarios(status:PUBLISHED){idCredito titulo resumen{html} descripcion{html} imagen{urls} bag{contentItems{... on TituloDescripcion{title description{html}}}} urlFormularioSoliciteCredito{url text}} aCBotonSoliciteSuCredito{ imagen{urls} imagen2x{urls} imagen3x{urls}}}";
const CreditosProductivosRoute =
  rootApiCMS +
  "?query={aCCreditosProductivos(status:PUBLISHED){idCreditoProductivo titulo resumen{html} imagen{urls} descripcion{html} urlformulariosolicitesucredito{text url} bag{contentItems{... on TituloDescripcion{title description{html}}}}} aCBotonSoliciteSuCredito{imagen{urls} imagen2x{urls} imagen3x{urls}}}";
const ahorrosProgramadosRoute =
  rootApiCMS +
  "?query={aCAhorroProgramado(status:PUBLISHED){idAhorro titulo resumen{html} descripcion{html} imagen{urls} bag{contentItems{... on TituloDescripcion{title description{html}}}} urlFormularioSoliciteAqui{text url}} aCBotonAhorro{ imagen{urls}}}";

const serviahorroRoute =
  rootApiCMS +
  "?query={serviahorro(status:PUBLISHED){titulo descripcion{html} botonEnlaceImagen{urls} botonEnlaceUrl{url}}}";
const inversionesRoute =
  rootApiCMS +
  "?query={aCInversion(status:PUBLISHED){titulo descripcion{html} resumen{html} idInversion bag{contentItems{... on TituloDescripcion{title description{html}}}} archivos{contentItems{... on ACDocumentoDescargable{tituloEnlace archivo{urls}}}}}}";
const historiaRoute =
  rootApiCMS +
  "?query={aCHistoria(status:PUBLISHED){titulo descripcion{html}}}";
const delegadosRoute =
  rootApiCMS +
  "?query={aCDelegados(status:PUBLISHED){titulo descripcion{html} archivosDescargables{contentItems{... on ACDocumentoDescargable{tituloEnlace archivo{urls}}}}}}";
const asistenciaRoute =
  rootApiCMS +
  "?query={plandeAsistencia(status:PUBLISHED){imagen{urls} nombre resumenPlan{html} tituloCostodelaasistencia textoCostodelaasistencia{html} tituloDescripciongeneral textoDescripciongeneral{html} ruta{contentItems{...on Ruta{component title url name keywords h1}}} notaAlPie{html} botones{contentItems{...on ACBotonPlan{displayText imagen{urls} ruta{text url} mostrarEnDetalle mostrarEnListado}}} serviciosAsistencia{contentItems{...on ACServicioDeAsistencia{servicio{html} limitedesuma eventos}}} archivosDescargables{contentItems{...on ACDocumentoDescargable{tituloEnlace archivo{urls}}}}}}";

const tarjetasRoute =
  rootApiCMS +
  "?query={aCTarjetadeCredito(status:PUBLISHED){titulo descripcion{html} imagen{urls} bag{contentItems{...on TituloDescripcion{title description{html}}}} botones{contentItems{...on ACBoton{ruta{url text} imagen{urls}}}} archivosDescargables{contentItems{...on ACDocumentoDescargable{tituloEnlace archivo{urls}}}}}}";

/*
  
  rootApiCMS +
  "?query={aCTarjetadeCredito(status:PUBLISHED){titulo descripcion{html} imagen{urls} bag{contentItems{... on TituloDescripcion{title description{html}}}} botones{contentItems{... on ACBoton{ruta{url text} imagen{urls}}}}}}";
*/
const tipsDeSeguridadRoute =
  rootApiCMS +
  "?query={aCTipsdeSeguridad(status: PUBLISHED){titulo{html} bag{contentItems{... on acTipdeseguridad{displayText icono{urls} descripcion{html}}}}}}";

const bienesBannerRoute =
  rootApiCMS +
  "?query={bannerdeBienes(status:PUBLISHED){imagendefondo{urls} imagendefondoMovil{urls} imagendeFondoIpadPortrait{urls} heroImage{urls} copyText} aCBienesBotonVerDetalle{imagen{urls}} aCBienesBotonSolicitarInformacion{imagenFullHD{urls} imagenIPad{urls} imagenIPhone{urls} enlace} aCBienesBotonCotizar{imagenFullHD{urls} imagenIPad{urls} imagenIPhone{urls} enlace}}";
const afiliacionRoute =
  rootApiCMS +
  "?query={afiliacion(status: PUBLISHED){titulo descripcion{html} botonAfiliacion{urls} botonAfiliacionIpad{urls} botonAfiliacionMovil{urls} uRLFormularioAfiliacion{text url} detalles{contentItems{... on TituloDescripcion{title description{html}}}} archivosDescargables{contentItems{... on ACDocumentoDescargable{tituloEnlace archivo{urls}}}}}}";
const organizacionRoute =
  rootApiCMS +
  "?query={aCOrganizacion(status:PUBLISHED){titulo descripcion{html} bag{contentItems{... on ACSeccionDescargables{archivosDescargables{contentItems{... on ACDocumentoDescargable{tituloEnlace archivo{urls}}}} titulo}}}}}";

const firmaDigitalRoute =
  rootApiCMS +
  "?query={aCFirmaDigital(status:PUBLISHED){titulo{html} descripcion{html} boton{urls} urlAC{url} urlCS{url}}}";

const reglamentosRoute =
  rootApiCMS +
  "?query={aCReglamento(status: PUBLISHED) {titulo{html} descripcion{html}} aCReglamentoArchivosDescargables(status: PUBLISHED) {archivo{urls} tituloEnlace}}";

const promocionesRoute =
  rootApiCMS +
  "?query={bannerPromociones{displayText imagendeFondo{urls} imagendeFondoIPad{urls} imagendeFondoMovil{urls} imagenPrincipal{urls} copyText{html}} aCPromociones{promociones{contentItems{... on PromocionItem{displayText tituloPromocion{html} slogan{html} promocion{html} descripcion{html} nota{html} imagenPromocion{urls} imagenBoton{urls} uRLImagenBoton{url}}}}}}";

const resumeBannerRoute =
  rootApiCMS +
  "?query={aCResumen{resumElements{contentItems{... on ResumeItem{titulo imagen{urls} descripcion{html} imagenBotonAccion{urls} urlBotonAccion{url text}}}}}}";

const comunicadosRoute =
  rootApiCMS +
  "?query={aCComunicadosOficiales(status: PUBLISHED) {icono{urls} titulo descripcion{html} textoBoton enlaceBoton}}"

const gestionPagosRoute =
  rootApiCMS +
  "?query={aCGestionPagos(status: PUBLISHED) {texto{html} imagen{urls} textoBoton{text url}}}"

const rutasAhorroYCredito = {
  calculadoraCredito: rootCreditos,
  sucursales: sucursalesRoute,
  convenios: conveniosRoute,
  perfilCorporativo: perfilCorporativoRoute,
  creditosPersonales: creditosPersonalesRoute,
  creditosHipotecarios: creditosHipotecariosRoute,
  CreditosProductivos: CreditosProductivosRoute,
  ahorrosProgramados: ahorrosProgramadosRoute,
  serviahorro: serviahorroRoute,
  inversiones: inversionesRoute,
  historia: historiaRoute,
  delegados: delegadosRoute,
  planesAsistencia: asistenciaRoute,
  tarjetas: tarjetasRoute,
  tipsDeSeguridad: tipsDeSeguridadRoute,
  bienesBanner: bienesBannerRoute,
  afiliacion: afiliacionRoute,
  organizacion: organizacionRoute,
  firmaDigital: firmaDigitalRoute,
  reglamentos: reglamentosRoute,
  promociones: promocionesRoute,
  resumeBanner: resumeBannerRoute,
  comunicadosOficiales: comunicadosRoute,
  gestionPagos: gestionPagosRoute
};

export default rutasAhorroYCredito;
